import moment from "moment";
import {
  createContext,
  FunctionComponent,
  SetStateAction,
  useContext,
  useEffect,
  useState,
} from "react";

import { CustomerDetailModel } from "../service/models/orders/customer_detail_model";
import {
  defaultOrderVal,
  OrderModel,
} from "../service/models/orders/order_model";
import {
  subscriptionPlanDefault,
  SubscriptionPlanModel,
} from "../service/models/orders/subscription_plan_model";
import { ApiResponse } from "../service/models/response";
import { TransactionDataModel } from "../service/models/trannsaction_model";
import {
  CreateOrderApi,
  GetLastOrderOfCustomerApi,
  GetOrderNumberApi,
} from "../service/repos/order_repo";

import { Step } from "../ui/new_components/common/stepper_widget";

import { GetTxnAmt } from "../utils/order_util";
import { useModal } from "./modal/modal_context";
import { ToastType, useToast } from "./toast/toast_ctx";
import { ItemModelV2 } from "../erp/inventory/models/item_model";
import { defaultCustomer } from "./auth/user_model";

import { useHistory } from "react-router-dom";

interface OrderCreateCtxModel {
  setAttachments: React.Dispatch<
    SetStateAction<
      {
        category: string;
        file: File;
      }[]
    >
  >;
  attachments: {
    category: string;
    file: File;
  }[];
  order: OrderModel;
  setOrder: React.Dispatch<React.SetStateAction<OrderModel>>;
  // products: ProductModel[];
  items: ItemModelV2[];
  setUser: React.Dispatch<
    React.SetStateAction<CustomerDetailModel | undefined>
  >;
  user?: CustomerDetailModel;
  setBilling: React.Dispatch<
    React.SetStateAction<CustomerDetailModel | undefined>
  >;
  billing?: CustomerDetailModel;
  setDeliveryProfile: React.Dispatch<
    React.SetStateAction<CustomerDetailModel | undefined>
  >;
  deliveryProfile?: CustomerDetailModel;
  billingProfile?: CustomerDetailModel;
  balTxns: TransactionDataModel[];
  balTxnAmt: number;
  useBal: boolean;
  setUseBal: React.Dispatch<React.SetStateAction<boolean>>;
  setStep: (s: number) => void;
  step: number;
  steps: Step[];
  onCreateOrder: () => Promise<{
    success: boolean;
    message?: string;
    error?: string;
  }>;
  setSubscription: React.Dispatch<SetStateAction<SubscriptionPlanModel>>;
  subscription: SubscriptionPlanModel;
  setSubscriptionReq: React.Dispatch<SetStateAction<boolean>>;
  subscriptionReq: boolean;
  namespaces: {
    name: string;
    namespace: string;
  }[];
  setNamespaces: React.Dispatch<
    SetStateAction<
      {
        name: string;
        namespace: string;
      }[]
    >
  >;
  reset: (order_id?: boolean) => Promise<void>;
  lastOrder?: OrderModel;
  selectLastOrder: () => void;
  setPrefilled: React.Dispatch<SetStateAction<boolean>>;
  prefilled: boolean;
}
const defaultVal: OrderCreateCtxModel = {
  steps: [],
  onCreateOrder: async () =>
    Promise.resolve({ success: false, message: "", error: "" }),
  step: 0,
  setStep: () => {},
  useBal: false,
  setUseBal: () => {},
  balTxnAmt: 0,
  balTxns: [],
  order: defaultOrderVal,
  setOrder: () => {},
  // products: [],
  items: [],
  setUser: () => {},
  user: {
    ...defaultCustomer,
    firstName: "",
    alt_mobile: "",
    mobile: "",
    address: {
      line1: "",
      city: "",
      state: "",
      country: "",
      pincode: 0,
    },
  },
  setBilling: function (
    value: SetStateAction<CustomerDetailModel | undefined>,
  ): void {
    throw new Error("Function not implemented.");
  },
  subscription: subscriptionPlanDefault,
  setSubscription: () => {},
  setAttachments: function (
    value: SetStateAction<{ category: string; file: File }[]>,
  ): void {
    throw new Error("Function not implemented.");
  },
  attachments: [],
  namespaces: [],
  setNamespaces: function (
    value: SetStateAction<{ name: string; namespace: string }[]>,
  ): void {
    throw new Error("Function not implemented.");
  },
  reset: async () => {},
  setSubscriptionReq: function (value: SetStateAction<boolean>): void {
    throw new Error("Function not implemented.");
  },
  subscriptionReq: false,
  selectLastOrder: () => {},
  setPrefilled: function (value: SetStateAction<boolean>): void {
    throw new Error("Function not implemented.");
  },
  prefilled: false,
  setDeliveryProfile: function (
    value: SetStateAction<CustomerDetailModel | undefined>,
  ): void {
    throw new Error("Function not implemented.");
  },
};

const defautSteps: Step[] = [
  { label: "Customer", required: true, validated: false },
  {
    label: "Order Detail",
    required: true,
    validated: false,
  },
  { label: "Products", required: true, validated: false },
  { label: "Consumption", required: false, validated: false },
  { label: "Subscription", required: false, validated: false },
  { label: "Payments", required: false, validated: false },
  { label: "Attachments", required: false, validated: false },
];
const context = createContext<OrderCreateCtxModel>(defaultVal);
export const useOrderCreateCtx = () => useContext(context);
interface OrderCreateContextProps {
  children?: any;
}

const OrderCreateContext: FunctionComponent<OrderCreateContextProps> = ({
  children,
}) => {
  const { showToast } = useToast();
  const [attachments, setAttachments] = useState<
    { category: string; file: File }[]
  >([]);
  const [subscription, setSubscription] = useState<SubscriptionPlanModel>({
    ...subscriptionPlanDefault,
  });
  const [subscriptionReq, setSubscriptionReq] = useState(false);
  const [namespaces, setNamespaces] = useState<
    {
      name: string;
      namespace: string;
    }[]
  >([]);
  const [order, setOrder] = useState<OrderModel>(defaultOrderVal);
  const [lastOrder, setLastOrder] = useState<OrderModel | undefined>();
  const [prefilled, setPrefilled] = useState(false);

  // We are moving to ItemModelv2
  const [items, setItems] = useState<ItemModelV2[]>([]);
  // const [products, setProducts] = useState<ProductModel[]>([]);

  const { setLoading } = useModal();
  const navigation = useHistory();
  const [balTxns, setBalTxns] = useState<TransactionDataModel[]>([]);
  const [balTxnAmt, setBalTxnAmt] = useState(0);
  const [useBal, setUseBal] = useState(false);
  const [step, setStep] = useState(0);
  const [user, setUser] = useState<CustomerDetailModel>();
  const [billing, setBilling] = useState<CustomerDetailModel>();
  const [deliveryProfile, setDeliveryProfile] = useState<CustomerDetailModel>();
  const [steps, setSteps] = useState<Step[]>([]);

  useEffect(() => {
    console.log("Order Object", order);
    console.log("User Object", user);
    console.log("Billing Object", billing);
    console.log("Delivery Object", deliveryProfile);
  }, [order, user, billing, deliveryProfile]);

  useEffect(() => {
    if (!lastOrder) return;

    setOrder((prev) => ({
      ...prev,
      sales_person_id: prev.sales_person_id ?? lastOrder.sales_person_id,
      sales_person_name: prev.sales_person_name ?? lastOrder.sales_person_name,
      rm_uid: prev.rm_uid ?? lastOrder.rm_uid,
      rm_name: prev.rm_name ?? lastOrder.rm_name,
    }));
  }, [lastOrder]);

  const reset = async (order_id?: boolean) => {
    if (order_id) {
      const orderNumberRes: ApiResponse = await GetOrderNumberApi();

      if (orderNumberRes.success) {
        const order_id = orderNumberRes.data.order_id;
        setOrder((o) => ({ ...defaultOrderVal, order_id }));
      } else showToast({ type: ToastType.error, text: orderNumberRes.error });
    } else {
      setOrder((o) => ({ ...defaultOrderVal }));
    }

    setBalTxnAmt(0);
    setBalTxns([]);
    setStep(0);
    setSubscription({ ...subscriptionPlanDefault });
    setUser(undefined);
    setBilling(undefined);
    setDeliveryProfile(undefined);
    setSteps((o) =>
      o.map((s) => {
        s.validated = false;
        return s;
      }),
    );
  };
  useEffect(() => {
    if (user) {
      setBilling(undefined);
      getLastOrder();
    }
  }, [user]);

  const init = async () => {
    setLoading(true);
    setSteps((o) => [...defautSteps]);
    const orderNumberRes: ApiResponse = await GetOrderNumberApi();

    if (orderNumberRes.success) {
      const order_id = orderNumberRes.data.order_id;
      setOrder((o) => ({ ...defaultOrderVal, order_id }));
    } else showToast({ type: ToastType.error, text: orderNumberRes.error });
    // if (products.length === 0) {
    //   const productRes = await GetProductsApi();
    //   if (productRes.success) {
    //     setProducts(productRes.data);
    //   } else showToast({ type: ToastType.error, text: productRes.error });
    // }

    setLoading(false);
  };

  useEffect(() => {
    init();
  }, []);

  useEffect(() => {
    setSteps((o) => [
      ...o.map((s, i) => {
        if (i === 4) {
          s.required = subscriptionReq;
        }
        return s;
      }),
    ]);
  }, [subscriptionReq]);

  const selectLastOrder = () => {
    if (!lastOrder) return;
    const {
      type,
      category,
      segment,
      source,
      sales_person_id,
      sales_person_name,
      rm_uid,
      rm_name,
      rm2_name,
      rm2_uid,
      discom,
      meter_type,
      load_sanction,
      registration_doc_issued,
      no_device_registered,
    } = lastOrder!;
    setOrder((ol) => ({
      ...ol,
      type,
      category,
      segment,
      source,
      sales_person_id,
      sales_person_name,
      rm_uid,
      rm_name,
      rm2_name,
      rm2_uid,
      discom,
      meter_type,
      load_sanction,
      registration_doc_issued,
      no_device_registered,
    }));
  };
  const getLastOrder = async () => {
    setLoading(true);
    const res = await GetLastOrderOfCustomerApi(user!.uid);
    if (res.success) {
      // console.log("Last Order Data", res.data.sales_person_id);
      setLastOrder(res.data);
    } else {
      showToast({ type: ToastType.error, text: res.error });
    }
    setLoading(false);
  };

  const onCreateOrder = async () => {
    setLoading(true);
    try {
      const freeOfCostTypes = ["Free of cost"];

      // Use currency fields from order (fallback to INR)
      const currency = order.currency ?? {
        short_name: "INR",
        symbol: "₹",
        formal_name: "Indian Rupee",
      };
      const exchangeRate = order.currency_to_inr || 1; // INR per 1 unit of chosen currency
      const isNotINR = currency.short_name !== "INR";

      // validations
      if (!freeOfCostTypes.includes(order.sale_type)) {
        if (order.subtotal <= 0) {
          showToast({
            type: ToastType.error,
            text: "This order cannot have products with zero amount. Only 'Free of cost' sale type are allowed to have zero amount products.",
          });
          setLoading(false);
          return;
        }
      }

      if (order.sale_type === "Transfer order") {
        if (order.products.length > 0 || order.services.length > 0) {
          showToast({
            type: ToastType.error,
            text: "Transfer orders can only have 'Row Materials', not Products or Services.",
          });
          setLoading(false);
          return;
        }
      }

      // build FormData
      const form = new FormData();

      // user & txn attachments (these are separate file fields)
      order.user_id = user?.uid!;
      (order.transactionData || []).forEach((txn) => {
        if (txn.files && txn.files.length > 0) {
          form.append("txn_attachment", txn.files[0], txn.id);
        }
      });

      // customer portion
      order.customer_id = user?.uid!;
      order.customer = { ...user!, id: user?.uid }; // ensure fields exist
      // attach billing address to customer
      if (billing) order.customer.address = billing.address;

      // delivery / billing profiles
      order.delivery_profile = deliveryProfile!;
      order.billing_profile = billing!;
      order.billing_profile_id = billing?.id!;
      order.delivery_profile_id = deliveryProfile?.id!;

      // Prepare payload copy so we can convert INR equivalents without destroying client state
      const payload: any = { ...order };

      // Do not delete payload.order_id (server handles if missing) but we remove client only fields if needed
      delete payload._local_temp; // example: remove any client only props if present

      // Always send chosen currency metadata
      payload.currency = currency;
      payload.currency_to_inr = exchangeRate;

      // Add INR equivalents for top-level monetary fields so backend can use them if needed
      payload.subtotal_in_inr =
        (payload.subtotal || 0) * (isNotINR ? exchangeRate : 1);
      payload.excess_in_inr =
        (payload.excess || 0) * (isNotINR ? exchangeRate : 1);
      payload.discount_in_inr =
        (payload.discount || 0) * (isNotINR ? exchangeRate : 1);
      payload.paid_in_inr = (payload.paid || 0) * (isNotINR ? exchangeRate : 1);
      payload.total_in_inr =
        (payload.subtotal || 0 + payload.excess || 0 - payload.discount || 0) *
        (isNotINR ? exchangeRate : 1);
      payload.balance_in_inr =
        (payload.total_in_inr || 0) - (payload.paid_in_inr || 0);

      // Convert items: keep original price (in display currency) and add price_in_inr
      const convertItemsForPayload = (items: any[] = []) =>
        items.map((it: any) => ({
          ...it,
          price_in_inr: (it.price || 0) * (isNotINR ? exchangeRate : 1),
        }));

      if (payload.products)
        payload.products = convertItemsForPayload(payload.products);
      if (payload.services)
        payload.services = convertItemsForPayload(payload.services);
      if (payload.raw_materials)
        payload.raw_materials = convertItemsForPayload(payload.raw_materials);
      if (payload.excessData)
        payload.excessData = convertItemsForPayload(payload.excessData);

      // Convert transaction amounts to INR and include both versions
      if (payload.transactionData && payload.transactionData.length > 0) {
        payload.transactionData = payload.transactionData.map((txn: any) => ({
          ...txn,
          amount_in_inr: (txn.amount || 0) * (isNotINR ? exchangeRate : 1),
        }));

        // Append txn files already appended above as "txn_attachment"
      }

      // Keep payload.currency as original currency for display and server processing.
      // Do NOT override payload.currency to "INR" here.

      // Append main data
      form.append("data", JSON.stringify(payload));

      // subscription optional
      if (subscriptionReq)
        form.append("subscription", JSON.stringify(subscription));
      form.append("use_bal", `${useBal}`);

      // attachments (order attachments — separate from txn_attachment)
      const attachment_category: { [key: string]: string } = {};
      attachments.forEach((at, i) => {
        const { file, category } = at;
        const exe = file.name.split(".").pop();
        const fileName = `file-${i}.${exe}`;
        form.append("attachment", file, fileName);
        attachment_category[fileName] = category;
      });
      form.append("attachment_category", JSON.stringify(attachment_category));

      // Call API
      const res = await CreateOrderApi(form);

      setLoading(false);
      return res;
    } catch (err: any) {
      setLoading(false);
      return { success: false, error: err.message };
    }
  };

  const changeStep = (s: number) => {
    if (steps[step].required && step === 0 && s > step) {
      const valid =
        !billing || !deliveryProfile
          ? "Please select customer and billing profile! "
          : true;
      setSteps((o) =>
        o.map((f, i) => {
          if (i === step) {
            f.validated = typeof valid !== "string";
          }
          return f;
        }),
      );
      if (typeof valid === "string") {
        showToast({ type: ToastType.error, text: valid });
        return;
      }
    }
    if (steps[step].required && step === 1 && s > step) {
      const valid = orderDetailValidator(order);
      setSteps((o) =>
        o.map((f, i) => {
          if (i === step) {
            f.validated = typeof valid !== "string";
          }
          return f;
        }),
      );
      if (typeof valid === "string") {
        showToast({ type: ToastType.error, text: valid });
        return;
      }
    }
    if (steps[step].required && step === 2 && s > step) {
      const valid = orderDetailValidator(order);

      setSteps((o) =>
        o.map((f, i) => {
          if (i === step) {
            f.validated = typeof valid !== "string";
          }
          return f;
        }),
      );
      if (typeof valid === "string") {
        showToast({ type: ToastType.error, text: valid });
        return;
      }
    }
    if (steps[step].required && step === 2 && s > step) {
      const valid =
        order.products &&
        order.products.length === 0 &&
        order.services &&
        order.services.length === 0 &&
        order.raw_materials &&
        order.raw_materials.length === 0 &&
        order.sale_type !== "Transfer order"
          ? "Please select Product/Service/Raw Material"
          : true;
      console.log(step, valid);
      setSteps((o) =>
        o.map((f, i) => {
          if (i === step) {
            f.validated = typeof valid !== "string";
          }
          return f;
        }),
      );
      if (typeof valid === "string") {
        showToast({ type: ToastType.error, text: valid });
        return;
      }
    }
    if (steps[step].required && step === 4 && s > 4) {
      const valid =
        !subscription || !subscription.org_namespace
          ? "Please select subscription plan! "
          : true;
      setSteps((o) =>
        o.map((f, i) => {
          if (i === step) {
            f.validated = typeof valid !== "string";
          }
          return f;
        }),
      );
      if (typeof valid === "string") {
        showToast({ type: ToastType.error, text: valid });
        return;
      }
    }

    let allowed = true;
    for (let i = 0; i < s; i++) {
      const st = steps[i];

      if (st.required && !st.validated) {
        allowed = false;
        break;
      }
    }

    if (allowed) setStep(s);
  };

  const value: OrderCreateCtxModel = {
    order,
    setOrder,
    // products,
    items,
    user,
    setUser,
    billing,
    setBilling,
    balTxns,
    balTxnAmt,
    useBal,
    setUseBal,
    setStep: changeStep,
    step,
    onCreateOrder,
    steps,
    subscription,
    setSubscription,
    attachments,
    setAttachments,
    namespaces,
    setNamespaces,
    reset,
    subscriptionReq,
    setSubscriptionReq,
    lastOrder,
    selectLastOrder,
    prefilled,
    setPrefilled,
    setDeliveryProfile,
    deliveryProfile,
  };

  return <context.Provider value={value}>{children ?? <></>}</context.Provider>;
};

export default OrderCreateContext;

export const orderDetailValidator = (order: OrderModel) => {
  try {
    if (!order.order_date || !moment(order.order_date).isValid())
      return "Order date required !";
    if (!moment(order.order_date).isValid()) return "Order date is invalid !";
    if (!order.order_id) return "Order id required !";
    if (!order.type) return "Order type required !";
    // if (!order.segment) return "Order lead segment required !";
    // if (!order.source) return "Order lead source required !";
    if (
      !order.sale_type ||
      order.sale_type === undefined ||
      order.sale_type === ""
    )
      return "Please select a sales type";

    if (!order.sales_person_name || order.sales_person_name === "")
      return "Order sales person required !";
    if (!order.rm_name || order.rm_name === "")
      return "Order relationship manager required !";
    if (!order.status) return "Order status required !";

    return true;
  } catch (error: any) {
    return error.message;
  }
};
